import axios from "axios";

interface SignupPayload {
  username: string;
  phone: string;
  password: string;
}

const BASE_URL = process.env.REACT_APP_API_BASE_URL;

export const signupUser = async (data: SignupPayload) => {
  const response = await axios.post(
    `${BASE_URL}/api/users/`,
    {
      username: data.username,
      phone: data.phone,
      password: data.password,
    }
  );

  return response.data;
};


// export const loginUser = async (data: {
//   username_or_email: string;
//   password: string;
// }) => {
//   const response = await axios.post(
//     `${BASE_URL}/api/users/login/`,
//     data
//   );

//   return response.data;
// };

export const loginUser = async (data: {
  username_or_email: string;
  password: string;
}) => {
  try {
    const response = await axios.post(
      `${BASE_URL}/api/users/login/`,
      data
    );
    
    console.log(response);
    return response.data;

  } catch (error: any) {
    // Check if the error exists and has a response
    if (error.response) {
      // The request was made and the server responded with a status code
      // that falls out of the range of 2xx
      if (error.response.status === 401) {
        throw error;
      } else {
        console.error(`Server Error: ${error.response.status}`);
        throw new Error(`خطای سرور: ${error.response.status}`);
      }
    } else if (error.request) {
      // The request was made but no response was received
      console.error("Network Error: No response received.");
      throw new Error("ارتباط با سرور برقرار نشد.");
    } else {
      // Something happened in setting up the request that triggered an Error
      console.error("Error:", error.message);
      throw new Error("خطایی رخ داد.");
    }
  }
};
